import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=bbb59816&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=bbb59816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb59816",
  null
  
)

export default component.exports